// Layer: application. Depends on domain only.
import type { Action, Decision, ShiftView } from "../domain/types";
import type { StoriaApi } from "./ports";

export class LoadShift {
  constructor(private readonly api: StoriaApi) {}
  async exec(propertyId: string): Promise<ShiftView> {
    return this.api.loadShift(propertyId);
  }
}

export class DecideAction {
  constructor(private readonly api: StoriaApi) {}
  async exec(actionId: string, decision: Decision): Promise<Action> {
    return this.api.decide(actionId, decision);
  }
}

/**
 * Apply a decided action to a loaded shift view without refetching.
 *
 * The shift view shows only pending work, so a decided action leaves it. Doing this
 * locally rather than refetching keeps the list from jumping under a thumb on a tablet
 * mid-shift — the interaction this console exists for.
 */
export function withoutAction(view: ShiftView, actionId: string): ShiftView {
  const strip = (items: Action[]): Action[] =>
    items.filter((a) => a.id !== actionId);
  return {
    arriving: strip(view.arriving),
    in_stay: strip(view.in_stay),
    departing: strip(view.departing),
  };
}

export function countPending(view: ShiftView): number {
  return view.arriving.length + view.in_stay.length + view.departing.length;
}
